import { useCallback, useEffect, useRef, useState } from "react";
import { getMastermindPartnerList } from "../../services/partnerExpertService";
import { PartnerPostModel } from "./models/PartnerPostModel";

export const useMastermindPartner = (partnerId: number, page: number) => {
    const limit = 10;
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<PartnerPostModel[]>([]);
    const [filters, setFilters] = useState<{limit: number, offset: number}>({ limit, offset: 0 });
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const offset = (page - 1) * limit;
        setFilters({ limit, offset });
    }, [page]);
    
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            setList([]);
            const _result = await getMastermindPartnerList(partnerId, filters.limit, filters.offset)
            if(!isMountedRef.current)
                return;
            setList(_result.results);
            const _totalPages = Math.ceil(_result.count / limit);
            setTotalPages(_totalPages);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [filters]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, list, totalPages }
}